import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const F1Icon = ({ viewBox = '0 0 16 16', ...props }: SvgIconProps) => {
  return (
    <SvgIcon viewBox={viewBox} {...props}>
      <rect width="16" height="16" rx="4" fill="black" fillOpacity="0.13" />
      <path
        d="M4.22949 11.5H2.95117V3.64746H7.3877V4.73242H4.22949V7.18164H7.18359V8.26123H4.22949V11.5ZM11.9907 11.5H10.7231V6.4458C10.7231 6.27751 10.7249 6.10921 10.7285 5.94092C10.7321 5.77262 10.7357 5.60791 10.7393 5.44678C10.7464 5.28564 10.7554 5.13167 10.7661 4.98486C10.6909 5.06722 10.5978 5.15674 10.4868 5.25342C10.3794 5.3501 10.2648 5.45036 10.1431 5.5542L9.24072 6.27393L8.60693 5.47363L10.938 3.64746H11.9907V11.5Z"
        fill="#2C2E33"
      />
    </SvgIcon>
  );
};

export default F1Icon;
